<template>
  <v-app>
    <!-- セッションの有無関係無く表示可能 -->
    <router-view name="always" />
    <!-- セッションが無い場合（ログアウト状態）のみ表示可能 -->
    <router-view name="noSession" />

    <!-- Session Contents -->
    <router-view />

    <!-- Error Notification -->
    <ErrorNotification />
    <!-- Alert dialog -->
    <AlertDialog />

    <!-- Loading -->
    <v-progress-linear
      v-show="ui.loading"
      indeterminate
      height="3"
      color="secondary"
      style="position: fixed; z-index: 99999; margin: 0"
    />
  </v-app>
</template>

<script>
  import AlertDialog from '@/components/base/TheAlertDialog'
  import { mapGetters } from 'vuex'
  import { toLoginPage, toLoginSuccess } from './library/redirect'
  import ErrorNotification from './components/base/ErrorNotification.vue'
  import { jwtDecode } from 'jwt-decode'
  import { isTokenExpired, updateAccessToken } from './library/utils'

  export default {
    components: {
      ErrorNotification,
      AlertDialog
    },
    data: () => ({
      show: false
    }),
    computed: {
      ...mapGetters(['login', 'ui'])
    },
    created () {
      if (localStorage.getItem('token')) {
        if (isTokenExpired()) {
          updateAccessToken(this.verifyToken)
        } else this.verifyToken()
      } else {
        // Tokenが存在しない(=セッションが存在しない)
        // the router should automatically redict to login page
        console.error('login token does not exist. ')
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
      if (this.$vuetify.display.lgAndUp) {
        // 1280px < lgAndUp
        this.ui.leftDrawer = true
      }
    },
    methods: {
      handleScroll () {
        // 少しでもスクロールするとツールバーに影を付ける
        this.ui.toolbarElevation = window.scrollY > 0
        // 30px以上スクロースすると第1ツールバーを隠す
        this.ui.firstToolbarHide = window.scrollY > 20
      },
      verifyToken () {
        const token = localStorage.getItem('token')
        // verify the access token and session_id
        this.$http.post('token-verify/', { token: token }, { withCredentials: true }).then(
          (res) => {
            // ------------------------------------------------------------------------
            // セッションが存在する
            // ------------------------------------------------------------------------
            if (this.$route.matched.length && 'noSession' in this.$route.matched[0].components) {
              // セッション用では無いページ(loginやsignup)の場合、ログイン後ページへリダイレクト
              toLoginSuccess()
            } else if (!token) {
              toLoginPage()
            } else {
              this.login.user_id = jwtDecode(token).user_id
              this.$http.get(`users/${this.login.user_id}/`).then((res) => {
                res.data.is_admin = false
                res.data.roles.forEach((role) => {
                  if (role === 'admin') {
                    res.data.is_admin = true
                  }
                })
                this.$store.dispatch('login', { profile: res.data })
                this.$i18n.locale = res.data.language
                // 組織情報ゲット
                this.$http.get(`customers/${this.login.profile.customer}/`).then((res) => {
                  this.$store.dispatch('login', { customer: res.data })
                })
              }).catch((error) => {
                console.error('failed to get user info: ', error)
              })
              this.show = true
            }
          },
          (error) => {
            // ------------------------------------------------------------------------
            // セッションエラー（セッション切れ）
            // ------------------------------------------------------------------------
            if (this.$route.matched.length && ('noSession' in this.$route.matched[0].components || 'always' in this.$route.matched[0].components)) {
              //   現在ログインページの場合
              this.show = true
            } else {
              // 現在ログインページ以外の場合
              // URLをGETパラメータに埋め込んでログインページヘリダイレクト
              console.log(error)
              toLoginPage()
            }
          }
        )
      }
    }
  }
</script>

<style>

  html {
    overflow-y: auto;
    font-size: 14px;
  }

  a {
    color: #29a9cf !important;
    text-decoration: none;

  }

  .theme--light.application {
    background: #fff !important;
    color: rgba(0, 0, 0, .87) !important;
  }

  .card-style {
    border: 1px solid rgba(0, 0, 0, .15) !important;
    border-radius: 8px !important;
  }

  .pointer {
    cursor: pointer
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #999;
    border-radius: 2px;
  }

  .content-top-margin {
    margin-top: 112px;
  }

  .v-navigation-drawer__border {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 0 !important;
  }

  /* Vuetify Input デザイン上書き */
  .theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
    border: 1px solid rgba(0, 0, 0, .25)
  }

  .theme--light.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot:hover {
    border: 1px solid rgba(0, 0, 0, .3)
  }

  .theme--dark.v-text-field--outline > .v-input__control > .v-input__slot {
    border: 1px solid hsla(0, 0%, 100%, .7)
  }

  .theme--dark.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot:hover {
    border: 1px solid #fff
  }


  .v-text-field--outline.v-input--has-state > .v-input__control > .v-input__slot, .v-text-field--outline.v-input--is-focused > .v-input__control > .v-input__slot {
    border: 2px solid;
    transition: border .3s cubic-bezier(.25, .8, .5, 1)
  }

  /* Vuetify btn group デザイン上書き */
  .v-btn-toggle--selected {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border: 1px solid rgba(0, 0, 0, .25)
  }
</style>

